import React, {useCallback, useEffect, useMemo, useState} from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import HorizontalLoader from '../../../../components/HorizontalLoader';
import PaymentMethods from '../../../../components/PaymentMethods';
import Popup from '../../../../components/Popup';
import ENDPOINT from '../../../../constants/endpoints';
import UxHelpers from '../../../../helpers/ux-helpers';
import useApi from '../../../../hooks/useApi';
import Dialog from '../../index';
import ResponseErrorDialog from '../ResponseErrorDialog';

const SelectPaymentMethodDialog = props => {
  const { show, proceed, dismiss } = props;
  const [info, setInfo] = useState({
    loading: true,
    paymentMethods: [],
  });
  const api = useApi();
  const [selected, setSelected] = useState(props.method ? props.method.id : null);

  useEffect(() => {
    api.getRequest(
      ENDPOINT.FORM.GET.ACCOUNT_PLAN,
      {},
      {
        handleError: response => ResponseErrorDialog({ response }),
        handleSuccess: response => {
          setInfo({ ...info, ...response, loading: false });
        },
      }
    );
  }, []);

  const proceedHandler = useCallback(() => {
    proceed(selected);
    UxHelpers.overflowLock('unlock');
  }, [selected]);

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={() => { dismiss() }}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Cancel"
      />
      <BasicButton
        controlFunc={proceedHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Update"
      />
    </BasicButtonGroup>
  );

  const body = useMemo(() => {
    return (
      <Dialog>
        <div style={{ textAlign: 'center' }}>
          Select a payment method to use with your {props.plan || ''} plan.
        </div>
        {info.loading && (
          <HorizontalLoader />
        )}
        {!info.loading && (
          <PaymentMethods
            extended={true}
            selected={selected}
            onSelect={(id) => {
              setSelected(id);
            }}
            data={info.paymentMethods}
            canAdd={true}
          />
        )}
      </Dialog>
    )
  }, [info.loading, info.paymentMethods, props.plan, selected]);

  return (
    show && (
      <Popup
        className={'payment-methods-dialog'}
        title={'Select a payment method'}
        actions={{ proceed, dismiss }}
        buttonsRender={buttons}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(SelectPaymentMethodDialog));
